module.exports = "/_next/static/images/657fcc6f125140e4189776e5c4e64816-woman-using-cellphone@0.75x.jpg";